import { connect } from 'react-redux';
import { ThunkDispatch } from 'redux-thunk';
import { withLDConsumer } from 'launchdarkly-react-client-sdk';
import View from './view';
import { ReduxState } from '../../types/redux_types';
import { Action, ActionType, OtaComplianceAccount } from '../../types/global_reducer';
import { apiPostComplianceAcknowledgement } from '../../actions/api';
import logger from '../../logger';
import history from '../../history';
import { updateOtaCompliance } from '../../actions';

const mapStateToProps = (state: ReduxState) => ({
  otaCompliance: state.global.otaCompliance,
  visible: state.global.showOtaComplianceModal,
});

/* istanbul ignore next */
const mapDispatchToProps = (dispatch: ThunkDispatch<ReduxState, void, Action>) => ({
  actions: {
    hideModal: () => {
      history.replace({
        pathname: history.location.pathname,
        search: history.location.search,
        hash: '',
      });
      dispatch({ type: ActionType.SET_OTA_COMPLIANCE_MODAL, payload: false });
    },
    submitApproval: async (nonCompliantAccounts?: OtaComplianceAccount[]) => {
      try {
        const accountsToAck =
          nonCompliantAccounts
            ?.filter(account => !account.previouslyAcknowledged)
            ?.map(account => account.accountGuid) || [];
        if (accountsToAck && accountsToAck.length > 0) {
          await apiPostComplianceAcknowledgement(accountsToAck);
        }
      } catch (error) {
        logger.error(`Failed to post compliance acknowledgement: ${error}`);
      }

      dispatch({ type: ActionType.SET_OTA_COMPLIANCE_MODAL, payload: false });

      if (nonCompliantAccounts?.length === 1) {
        history.replace({
          pathname: `/ota/overview/${nonCompliantAccounts[0].accountGuid}`,
          search: history.location.search,
          hash: '',
        });
      } else if (nonCompliantAccounts && nonCompliantAccounts.length > 1) {
        history.replace({
          pathname: '/ota',
          search: history.location.search,
          hash: '',
        });
      }
    },
    updateOtaCompliance: () => dispatch(updateOtaCompliance()),
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(withLDConsumer()(View));
